import React from 'react';
import PropTypes from 'prop-types';
import equal from 'deep-equal';
import styled from 'styled-components';

class JsonEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      objectJson: JSON.stringify(props.object, null, 2),
      valid: true,
    };
  }
  componentWillReceiveProps(newProps) {
    if (!equal(this.props.object, newProps.object)) {
      // We assume the object passed in is always valid, so set valid to true if we receive new props
      this.setState({ objectJson: JSON.stringify(newProps.object, null, 2), valid: true });
    }
  }
  onChange(e) {
    this.setState({ objectJson: e.target.value });

    // Check that the JSON is valid before we bubble it up
    let parsedJson;
    try {
      parsedJson = JSON.parse(e.target.value);
      this.setState({ valid: true });
    } catch (error) {
      this.setState({ valid: false });
    }

    if (parsedJson) {
      this.props.onChange({ object: parsedJson, valid: true });
    } else {
      this.props.onChange({ object: null, valid: false });
    }
  }
  render() {
    return (
      <JsonTextArea className={this.state.valid ? 'valid-json' : 'invalid-json'} value={this.state.objectJson} onChange={(e) => this.onChange(e)} />
    );
  }
}

const JsonTextArea = styled.textarea`
  width: 85%;
  height: 400px;
  background-color: #eee;
  padding: 15px;

  &.invalid-json {
    box-shadow: 0px 0px 10px 2px #ebccd1;
    color: #a94442;
  }
`;

JsonEditor.propTypes = {
  object: PropTypes.object,
  onChange: PropTypes.func,
};

export default JsonEditor;



// WEBPACK FOOTER //
// ./app/components/FormControls/CdfEditor/JsonEditor.js